import React from 'react';
import { SearchIcon } from './Icons';
import './SearchBar.css';

const SearchBar = () => {
  return (
    <div className="search-section">
      <div className="search-bar">
        <div className="search-icon">
          <SearchIcon />
        </div>
        <input type="text" placeholder="Search" className="search-input" />
      </div>
    </div>
  );
};

export default SearchBar; 